import React from 'react';
import { Trash2 } from 'lucide-react';

export const CartItems = ({ cart, updateQuantity, updatePrice, removeItem, toggleItemTax, isPwo }) => (
  <div className="bg-card rounded-lg border border-border">
    <div className="p-6 border-b border-border">
      <h3 className="text-lg font-semibold">Order Items ({cart.length})</h3>
    </div>
    <div className="divide-y divide-border">
      {cart.length === 0 ? (
        <div className="p-12 text-center text-muted-foreground" data-testid="empty-cart">
          Cart is empty. Scan a product or add a manual item.
        </div>
      ) : (
        cart.map((item, index) => (
          <div key={index} className="p-4 flex items-center gap-4" data-testid={`cart-item-${index}`}>
            <div className="flex-1">
              <p className="font-medium">{item.variant_name}</p>
              <p className="text-sm text-muted-foreground">
                {item.sku ? <span className="font-mono">{item.sku}</span> : <span className="italic">Manual item</span>}
              </p>
            </div>
            <div className="flex items-center gap-3">
              {isPwo && (
                <button onClick={() => toggleItemTax(index)}
                  className={`px-2 py-0.5 text-xs rounded-full ${item.is_taxable !== false ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-500'}`}
                  data-testid={`cart-tax-${index}`}>
                  {item.is_taxable !== false ? 'Taxable' : 'Non-Tax'}
                </button>
              )}
              <input type="number" min="1" value={item.quantity}
                onChange={(e) => updateQuantity(index, e.target.value)}
                className="w-16 px-2 py-1.5 border border-input rounded-md text-center text-sm" />
              <div className="w-24">
                <input type="number" step="0.01" min="0" value={item.unit_price}
                  onChange={(e) => updatePrice(index, e.target.value)}
                  className="w-full px-2 py-1.5 border border-input rounded-md text-right text-sm" />
              </div>
              <p className="font-semibold tabular-nums w-24 text-right">${item.total.toFixed(2)}</p>
              <button onClick={() => removeItem(index)} className="p-1.5 text-red-600 hover:bg-red-50 rounded-md">
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  </div>
);
